const NORMAL = 'normal'
const FIXED = 'fixed'
const PROPORTIONAL = 'proportional'

const RATES = [
    { text: 'Residencial', disabled: true },
    { text: '1' }, { text: '1A' },{ text: '1B' },{ text: '1C' },
    { text: '1D' },{ text: '1E' },{ text: '1F' },{ text: 'DAC' },
    { text: 'Comercial', disabled: true },
    { text: 'PDBT' },{ text: 'GDMT' },
    { text: 'Industrial', disabled: true },
    { text: 'GDMTH' },{ text: 'GDMTO' }
]

export {
    NORMAL,
    FIXED,
    PROPORTIONAL,
    RATES
}